export default __webpack_public_path__ + "static/media/bg-orange.e43f0e68.png";